/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMenuWithCategoriesModel as DigiworkMaitreDPosDtoMenuCreateMenuWithCategoriesModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Menu/create-menu-with-categories-model';

export interface CreateMenuWithCategories$Params {
      body?: DigiworkMaitreDPosDtoMenuCreateMenuWithCategoriesModel
}

export function createMenuWithCategories(http: HttpClient, rootUrl: string, params?: CreateMenuWithCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createMenuWithCategories.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createMenuWithCategories.PATH = '/api/gmn/Menu/createmenuwithcategories';
